import { create } from "zustand";

const useTicketStore = create((set) => ({
  // Options
  options: {
    owner_groups: [],
    problem_types: [],
    statuses: [],
  },
  setOptions: (options) => set({ options }),

  // Selected ticket
  selectedTicket: null,
  setSelectedTicket: (ticket) => set({ selectedTicket: ticket }),

  // Search and filters
  searchQuery: "",
  setSearchQuery: (query) => set({ searchQuery: query }),
  ticketFilterSearchQuery: {
    page: 1,
    search: "",
    status: ["O"],
    problemType: "",
    receiver: "",
    dba: [],
    ownerGroup: "",
    created: {
      from: "",
      to: "",
    },
    sortBy: "id",
    sortValue: "DESC",
  },
  // Sorting
  sortField: null,
  sortDirection: null,
  setSorting: (field, direction) =>
    set({ sortField: field, sortDirection: direction }),
  setTicketFilterSearchQuery: (query) =>
    set((state) => ({
      ticketFilterSearchQuery: {
        ...state.ticketFilterSearchQuery,
        ...query,
      },
    })),

  merchantTicketScopePowerappId: null,
  merchantTicketScopeDba: null,
  setMerchantTicketScope: (powerappId, dba) =>
    set({
      merchantTicketScopePowerappId: powerappId,
      merchantTicketScopeDba: dba,
    }),

  // Pagination
  pageCount: 0,
  currentPage: 1,
  setPageCount: (count) => set({ pageCount: count }),
  setCurrentPage: (page) => set({ currentPage: page }),
  totalItems: 0,
  itemsPerPage: 10,
  setTotalItems: (total) => set({ totalItems: total }),
  setItemsPerPage: (items) => set({ itemsPerPage: items }),

  // Tickets data
  tickets: [],
  setTickets: (tickets) => set({ tickets }),

  // Reset
  reset: () =>
    set({
      selectedTicket: null,
      searchQuery: "",
      ticketFilterSearchQuery: {
        page: 1,
        search: "",
        status: ["O"],
        problemType: "",
        receiver: "",
        dba: [],
        ownerGroup: "",
        created: {
          from: "",
          to: "",
        },
      },
      pageCount: 0,
      currentPage: 1,
      totalItems: 0,
      itemsPerPage: 10,
      tickets: [],
      merchantTicketScopePowerappId: null,
      merchantTicketScopeDba: null,
    }),
}));

export default useTicketStore;
